import store from "../store";
import type from "../store/type";

const Message = {
    info(message) {
        return store.dispatch(type.ALERT, {
            alertId:new Date().toString(),
            alertType: 'info',
            body: message,
            icon: 'mdi-information-outline'
        });
    },

    error(message) {
        return store.dispatch(type.ALERT, {
            alertId: new Date().toString(),
            alertType: 'error',
            body: message,
            icon: 'mdi-alert-octagon'
        });
    },

    success(message) {
        return store.dispatch(type.ALERT, {
            alertId: new Date().toString(),
            alertType: 'success',
            body: message,
            icon: 'mdi-check-circle-outline'
        });
    },

    warning(message) {
        return store.dispatch(type.ALERT, {
            alertId: new Date().toString(),
            alertType: 'warning',
            body: message,
            icon: 'mdi-alert'
        });
    }
};

export const MessagePlugin =  {
    install(Vue) {
        Vue.prototype.$message = Message
    }
}

export default Message
